'use client'

import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react'
import classes from './CarouselScrollArrow.module.css'

interface CarouselScrollArrowProps {
    onClick: () => void
    direction?: 'left' | 'right'
    className?: string
}

export default function CarouselScrollArrow({
    onClick,
    direction = 'right',
    className,
}: CarouselScrollArrowProps) {
    const label = direction === 'left' ? 'Scroll left' : 'Scroll right'

    return (
        <button
            type="button"
            className={className ? `${classes.arrow} ${className}` : classes.arrow}
            aria-label={label}
            onClick={onClick}
        >
            {direction === 'left' ? <IconChevronLeft size={20} /> : <IconChevronRight size={20} />}
        </button>
    )
}
